import { type ResetProps, type SetSwitchProps, type SetSwitchesProps, type BooleanObject } from 'src/types'


// === PRIMITIVES === //
const setSwitch = (dispatch: (arg0: SetSwitchProps) => void, switchID: string, boolean: boolean) => {
  dispatch({
    type: 'SET_SWITCH',
    switchID,
    boolean
  })
}

const setSwitches = (dispatch: (arg0: SetSwitchesProps) => void, booleans: BooleanObject[]) => {
  dispatch({
    type: 'SET_BOOLEANS',
    booleans
  })
}

const reset = (dispatch: (arg0: ResetProps) => void) => {
  dispatch({
    type: 'RESET'
  })
}

export {
  setSwitch,
  setSwitches,
  reset
}
